/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PortalAccessDto,
  PortalExtensionRequestBody,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiPortalMeAccess = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalAccessDto>(
      {url: `/api/portal/me/access`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeAccessInfiniteQueryKey = () => {
    return [
    'infinite', `/api/portal/me/access`
    ] as const;
    }

export const getGetApiPortalMeAccessQueryKey = () => {
    return [
    `/api/portal/me/access`
    ] as const;
    }


export const getGetApiPortalMeAccessInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeAccess>>>, TError = ProblemDetails>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeAccessInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeAccess>>> = ({ signal }) => getApiPortalMeAccess(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeAccessInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeAccess>>>
export type GetApiPortalMeAccessInfiniteQueryError = ProblemDetails


export function useGetApiPortalMeAccessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeAccess>>>, TError = ProblemDetails>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeAccess>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeAccessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeAccess>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeAccess>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeAccessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeAccess>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeAccessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeAccess>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeAccessInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeAccessQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeAccessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeAccess>>> = ({ signal }) => getApiPortalMeAccess(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeAccess>>>
export type GetApiPortalMeAccessQueryError = ProblemDetails


export function useGetApiPortalMeAccess<TData = Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeAccess>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeAccess<TData = Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeAccess>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeAccess<TData = Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeAccess<TData = Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeAccess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiPortalMeAccessExtensionRequest = (
    portalExtensionRequestBody?: PortalExtensionRequestBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalAccessDto>(
      {url: `/api/portal/me/access/extension-request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalExtensionRequestBody, signal
    },
      options);
    }




export const getPostApiPortalMeAccessExtensionRequestMutationOptions = <TError = PortalAccessDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeAccessExtensionRequest>>, TError,{data?: PortalExtensionRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeAccessExtensionRequest>>, TError,{data?: PortalExtensionRequestBody}, TContext> => {

const mutationKey = ['postApiPortalMeAccessExtensionRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeAccessExtensionRequest>>, {data?: PortalExtensionRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiPortalMeAccessExtensionRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeAccessExtensionRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeAccessExtensionRequest>>>
    export type PostApiPortalMeAccessExtensionRequestMutationBody = PortalExtensionRequestBody | undefined
    export type PostApiPortalMeAccessExtensionRequestMutationError = PortalAccessDto | ProblemDetails

    export const usePostApiPortalMeAccessExtensionRequest = <TError = PortalAccessDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeAccessExtensionRequest>>, TError,{data?: PortalExtensionRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeAccessExtensionRequest>>,
        TError,
        {data?: PortalExtensionRequestBody},
        TContext
      > => {
      return useMutation(getPostApiPortalMeAccessExtensionRequestMutationOptions(options), queryClient);
    }
    export const deleteApiPortalMeAccessExtensionRequest = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalAccessDto>(
      {url: `/api/portal/me/access/extension-request`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiPortalMeAccessExtensionRequestMutationOptions = <TError = ProblemDetails | PortalAccessDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiPortalMeAccessExtensionRequest>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiPortalMeAccessExtensionRequest>>, TError,void, TContext> => {

const mutationKey = ['deleteApiPortalMeAccessExtensionRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiPortalMeAccessExtensionRequest>>, void> = () => {


          return  deleteApiPortalMeAccessExtensionRequest(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiPortalMeAccessExtensionRequestMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiPortalMeAccessExtensionRequest>>>

    export type DeleteApiPortalMeAccessExtensionRequestMutationError = ProblemDetails | PortalAccessDto

    export const useDeleteApiPortalMeAccessExtensionRequest = <TError = ProblemDetails | PortalAccessDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiPortalMeAccessExtensionRequest>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiPortalMeAccessExtensionRequest>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteApiPortalMeAccessExtensionRequestMutationOptions(options), queryClient);
    }
